<!-- <div
    *ngIf="!globalToasterSerive.getToaster().show"
    class="tw-pt-[51px] tw-pb-[15px]"
></div> -->
<header
    class="tw-bg-[#0A0A75] !tw-text-white tw-select-none tw-left-0 tw-right-0 tw-z-[100] lg:tw-py-[13px]"
    [ngClass]="
        !globalToasterSerive.getToaster().show ? 'tw-top-0 tw-sticky' : ''
    "
>
    <app-global-toaster *ngIf="globalToasterSerive.getToaster().show" />
    <div
        class="tw-relative tw-items-center tw-flex tw-justify-between tw-h-[55px] tw-w-full tw-px-[5vw] lg:tw-px-[4vw]"
    >
        <div
            class="tw-overflow-auto lg:tw-overflow-hidden tw-font-[500] tw-bg-[#F2F5F8] tw-text-black tw-px-[10%] tw-h-[100vh] tw-py-10 tw-absolute tw-top-0 tw-left-0 tw-w-full tw-z-[999999]"
            *ngIf="mobileMenuOpen"
        >
            <div
                class="tw-flex lg:tw-hidden tw-justify-between tw-items-center"
            >
                <div class="tw-flex tw-items-center tw-gap-[3px]">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9976 5.87902 15.1539 3.84561 13.6542 2.34584C12.1544 0.846082 10.121 0.00244306 8 0ZM11.6762 7.38461C11.5385 4.57615 10.4569 2.59 9.57 1.41538C10.9471 1.74609 12.1862 2.49951 13.1135 3.57001C14.0408 4.64051 14.6099 5.97439 14.7408 7.38461H11.6762ZM5.55616 8.61538H10.4438C10.2662 11.8162 8.73385 13.7777 8 14.5385C7.26539 13.7769 5.73385 11.8154 5.55616 8.61538ZM5.55616 7.38461C5.73385 4.18385 7.26616 2.22231 8 1.46154C8.73462 2.22538 10.2662 4.18692 10.4438 7.38461H5.55616ZM6.43 1.41538C5.54308 2.59 4.46154 4.57615 4.32385 7.38461H1.25923C1.39015 5.97439 1.95916 4.64051 2.88647 3.57001C3.81377 2.49951 5.05287 1.74609 6.43 1.41538ZM1.25923 8.61538H4.32385C4.46385 11.4238 5.54308 13.41 6.43 14.5846C5.05287 14.2539 3.81377 13.5005 2.88647 12.43C1.95916 11.3595 1.39015 10.0256 1.25923 8.61538ZM9.56693 14.5846C10.4538 13.41 11.5331 11.4238 11.6731 8.61538H14.7377C14.607 10.0252 14.0384 11.3588 13.1117 12.4292C12.185 13.4997 10.9466 14.2534 9.57 14.5846H9.56693Z"
                            fill="black"
                        />
                    </svg>
                    <span
                        [attr.ga-event-id]="gtmTags?.en?.event"
                        [attr.ga-event-category]="gtmTags?.en?.event_category"
                        [attr.ga-event-label]="gtmTags?.en?.event_label"
                        ga-track="track"
                        class="tw-cursor-pointer"
                        [ngClass]="selecLang !== 'en' ? 'tw-opacity-50' : ''"
                        (click)="switchLanguage('en', true)"
                        >{{ "LANG.EN" | translate }}</span
                    >
                    |
                    <span
                        [attr.ga-event-id]="gtmTags?.bm?.event"
                        [attr.ga-event-category]="gtmTags?.bm?.event_category"
                        [attr.ga-event-label]="gtmTags?.bm?.event_label"
                        ga-track="track"
                        class="tw-cursor-pointer"
                        [ngClass]="selecLang !== 'bm' ? 'tw-opacity-50' : ''"
                        (click)="switchLanguage('bm', true)"
                        >{{ "LANG.BM" | translate }}</span
                    >
                </div>
                <div class="tw-block lg:tw-hidden">
                    <svg
                        class="tw-cursor-pointer"
                        (click)="mobileMenuOpenToggle()"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_6448_6754)">
                            <path
                                d="M1.69231 22L0 20.3077L9.30769 11L0 1.69231L1.69231 0L11 9.30769L20.3077 0L22 1.69231L12.6923 11L22 20.3077L20.3077 22L11 12.6923L1.69231 22Z"
                                fill="black"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_6448_6754">
                                <rect width="22" height="22" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <div class="tw-mt-8">
                <mobile-menu
                    [dropdownValues]="financingDropDownValues.subDropdownValues"
                    [label]="financingDropDownValues.label"
                    [dropDown]="true"
                />
            </div>
            <div class="tw-mt-4">
                <mobile-menu
                    [dropdownValues]="
                        beyondFinancingDropDownValues.subDropdownValues
                    "
                    [label]="beyondFinancingDropDownValues.label"
                    [dropDown]="true"
                />
            </div>
            <div class="tw-mt-4">
                <mobile-menu
                    [label]="jc3EsgJumpstartDropDownValues.label"
                    [href]="jc3EsgJumpstartDropDownValues.href"
                />
            </div>
            <div class="tw-mt-4">
                <mobile-menu
                    [label]="whatsNewDropDownValues.label"
                    [href]="whatsNewDropDownValues.href"
                />
            </div>
            <div class="tw-mt-4">
                <mobile-menu
                    [dropdownValues]="aboutDropDownValues.subDropdownValues"
                    [label]="aboutDropDownValues.label"
                    [dropDown]="true"
                />
            </div>
            <div class="tw-mt-6"></div>

            <div
                class="tw-flex tw-mt-10 tw-justify-center tw-gap-3 tw-items-center tw-cursor-pointer"
                *ngIf="!isAuthenticated"
            >
                <span
                    [attr.ga-event-id]="gtmTags.Login.event"
                    [attr.ga-event-category]="gtmTags.Login.event_category"
                    [attr.ga-event-label]="gtmTags.Login.event_label"
                    ga-track="track"
                    class="tw-w-full tw-text-center tw-py-2 tw-border-[2px] tw-text-primary-blue-dark tw-border-primary-blue-dark tw-rounded-full"
                    [routerLink]="['/login']"
                >
                    {{ "COMMON.LOGIN" | translate }}
                </span>
                <button
                    [attr.ga-event-id]="gtmTags.Get_Started.event"
                    [attr.ga-event-category]="
                        gtmTags.Get_Started.event_category
                    "
                    [attr.ga-event-label]="gtmTags.Get_Started.event_label"
                    ga-track="track"
                    [routerLink]="['/sign-up']"
                    class="tw-w-full tw-text-center tw-py-2 tw-border-[2px] tw-text-white tw-bg-[#003A70] tw-border-primary-blue-dark tw-rounded-full"
                >
                    {{ "COMMON.REGISTER_NOW" | translate }}
                </button>
            </div>
            <span
                class="tw-text-[14px] tw-opacity-70 tw-block tw-mt-6 tw-text-center tw-font-semibold"
                >{{ "FOOTER.FOLLOW_US" | translate }}</span
            >
            <div class="tw-flex tw-justify-center tw-gap-4 tw-mt-3">
                <a
                    [attr.ga-event-id]="gtmTagsSocial.Network_Facebook.event"
                    [attr.ga-event-category]="
                        gtmTagsSocial.Network_Facebook.event_category
                    "
                    [attr.ga-event-label]="
                        gtmTagsSocial.Network_Facebook.event_label
                    "
                    ga-track="track"
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=61552185373254"
                >
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 20.9003 4.99207 26.6346 11.5617 27.7884V18.2816H8V14.3301H11.5617V11.3184C11.5617 7.89294 13.6548 6 16.8603 6C18.3945 6 20 6.26699 20 6.26699V9.63107H18.2302C16.4877 9.63107 15.9452 10.6857 15.9452 11.767V14.3301H19.8356L19.2137 18.2816H15.9452V27.8345C15.27 27.9379 14.5801 27.9936 13.8779 27.9995C13.9185 27.9998 13.9593 28 14 28Z"
                            fill="#003A70"
                        />
                    </svg>
                </a>

                <a
                    [attr.ga-event-id]="gtmTagsSocial.Network_Instagram.event"
                    [attr.ga-event-category]="
                        gtmTagsSocial.Network_Instagram.event_category
                    "
                    [attr.ga-event-label]="
                        gtmTagsSocial.Network_Instagram.event_label
                    "
                    ga-track="track"
                    target="_blank"
                    href="http://www.instagram.com/cgcdigital.my"
                >
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M23.8 6.3C23.8 7.4598 22.8598 8.4 21.7 8.4C20.5402 8.4 19.6 7.4598 19.6 6.3C19.6 5.1402 20.5402 4.2 21.7 4.2C22.8598 4.2 23.8 5.1402 23.8 6.3Z"
                            fill="#003A70"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21ZM14 18.2C16.3196 18.2 18.2 16.3196 18.2 14C18.2 11.6804 16.3196 9.8 14 9.8C11.6804 9.8 9.8 11.6804 9.8 14C9.8 16.3196 11.6804 18.2 14 18.2Z"
                            fill="#003A70"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 13.44C0 8.73556 0 6.38334 0.915545 4.58648C1.72088 3.00592 3.00592 1.72088 4.58648 0.915545C6.38334 0 8.73556 0 13.44 0H14.56C19.2644 0 21.6167 0 23.4135 0.915545C24.9941 1.72088 26.2791 3.00592 27.0845 4.58648C28 6.38334 28 8.73556 28 13.44V14.56C28 19.2644 28 21.6167 27.0845 23.4135C26.2791 24.9941 24.9941 26.2791 23.4135 27.0845C21.6167 28 19.2644 28 14.56 28H13.44C8.73556 28 6.38334 28 4.58648 27.0845C3.00592 26.2791 1.72088 24.9941 0.915545 23.4135C0 21.6167 0 19.2644 0 14.56V13.44ZM13.44 2.8H14.56C16.9584 2.8 18.5888 2.80218 19.8491 2.90514C21.0767 3.00544 21.7044 3.18723 22.1423 3.41036C23.1961 3.94725 24.0527 4.80395 24.5896 5.85765C24.8128 6.29557 24.9946 6.92334 25.0949 8.15091C25.1978 9.41116 25.2 11.0416 25.2 13.44V14.56C25.2 16.9584 25.1978 18.5888 25.0949 19.8491C24.9946 21.0767 24.8128 21.7044 24.5896 22.1423C24.0527 23.1961 23.1961 24.0527 22.1423 24.5896C21.7044 24.8128 21.0767 24.9946 19.8491 25.0949C18.5888 25.1978 16.9584 25.2 14.56 25.2H13.44C11.0416 25.2 9.41116 25.1978 8.15091 25.0949C6.92334 24.9946 6.29557 24.8128 5.85765 24.5896C4.80395 24.0527 3.94725 23.1961 3.41036 22.1423C3.18723 21.7044 3.00544 21.0767 2.90514 19.8491C2.80218 18.5888 2.8 16.9584 2.8 14.56V13.44C2.8 11.0416 2.80218 9.41116 2.90514 8.15091C3.00544 6.92334 3.18723 6.29557 3.41036 5.85765C3.94725 4.80395 4.80395 3.94725 5.85765 3.41036C6.29557 3.18723 6.92334 3.00544 8.15091 2.90514C9.41116 2.80218 11.0416 2.8 13.44 2.8Z"
                            fill="#003A70"
                        />
                    </svg>
                </a>
                <a
                    [attr.ga-event-id]="gtmTagsSocial.Network_Youtube.event"
                    [attr.ga-event-category]="
                        gtmTagsSocial.Network_Youtube.event_category
                    "
                    [attr.ga-event-label]="
                        gtmTagsSocial.Network_Youtube.event_label
                    "
                    ga-track="track"
                    target="_blank"
                    href="https://www.youtube.com/@CGCDigitalMY"
                >
                    <svg
                        width="38"
                        height="26"
                        viewBox="0 0 38 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M33.0821 0.775825C34.6805 1.20372 35.9393 2.46145 36.3661 4.05984C37.143 6.95646 37.142 13 37.142 13C37.142 13 37.142 19.0435 36.3661 21.9402C35.9382 23.5385 34.6805 24.7973 33.0821 25.2242C30.1855 26 18.571 26 18.571 26C18.571 26 6.95646 26 4.05984 25.2242C2.46145 24.7963 1.20268 23.5385 0.775825 21.9402C0 19.0435 0 13 0 13C0 13 0 6.95646 0.775825 4.05984C1.20372 2.46145 2.46145 1.20268 4.05984 0.775825C6.95646 0 18.571 0 18.571 0C18.571 0 30.1855 0 33.0821 0.775825ZM24.5064 13.0001L14.8579 18.5711V7.42812L24.5064 13.0001Z"
                            fill="#003A70"
                        />
                    </svg>
                </a>
                <a
                    [attr.ga-event-id]="gtmTagsSocial.Network_Linkedin.event"
                    [attr.ga-event-category]="
                        gtmTagsSocial.Network_Linkedin.event_category
                    "
                    [attr.ga-event-label]="
                        gtmTagsSocial.Network_Linkedin.event_label
                    "
                    ga-track="track"
                    target="_blank"
                    href="https://www.linkedin.com/company/cgc-digital"
                >
                    <svg
                        aria-hidden="true"
                        width="34"
                        height="34"
                        viewBox="0 0 20 20"
                        fill="#003A70"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </a>
                <a
                    target="_blank"
                    [attr.ga-event-id]="gtmTagsSocial.Network_X.event"
                    [attr.ga-event-category]="
                        gtmTagsSocial.Network_X.event_category
                    "
                    [attr.ga-event-label]="gtmTagsSocial.Network_X.event_label"
                    ga-track="track"
                    href="https://twitter.com/cgcdigitalmy"
                >
                    <svg
                        aria-hidden="true"
                        width="38"
                        height="38"
                        viewBox="0 0 24 24"
                        fill="#003A70"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </a>
            </div>
            <div
                class="tw-absolute tw-bottom-0 tw-flex tw-justify-center tw-w-full tw-left-0"
            >
                <img
                    src="/assets/images/logo/header_desktop_white.png"
                    alt="logo"
                    [attr.ga-event-id]="gtmTags.IMSME_Icon_Top.event"
                    [attr.ga-event-category]="
                        gtmTags.IMSME_Icon_Top.event_category
                    "
                    [attr.ga-event-label]="gtmTags.IMSME_Icon_Top.event_label"
                    ga-track="track"
                    class="tw-cursor-pointer tw-h-auto tw-w-[120px]"
                    (click)="toHomePage()"
                />
            </div>
        </div>

        <div class="tw-block lg:tw-hidden tw-min-w-[80px]">
            <mat-icon
                class="tw-cursor-pointer tw-text-white"
                (click)="mobileMenuOpenToggle()"
            >
                menu
            </mat-icon>
        </div>

        <!-- Header main menu desktop -->
        <div
            class="tw-text-[14px] tw-hidden tw-gap-4 lg:tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-text-[#212121]- tw-text-white"
            [ngClass]="
                innerWidth > innerwidthBreakpoint
                    ? 'sm:tw-gap-8 lg:tw-gap-[15px]'
                    : 'tw-text-[13px] tw-gap-[1.3rem]'
            "
        >
            <ng-container *ngFor="let headerItem of headerDropdownValues">
                <span
                    *ngIf="headerItem.subDropdownValues"
                    class="tw-flex tw-items-center tw-text-[14px]"
                    (click)="toggleMenu(headerItem.label)"
                    [matMenuTriggerFor]="menu"
                >
                    {{ headerItem.label | translate }}
                    <mat-icon
                        class="tw-text-white !tw-h-[18px] !tw-w-[18px] !tw-text-[18px]"
                        (click)="toggleMenu(headerItem.label)"
                        >expand_more</mat-icon
                    >
                </span>

                <span
                    [attr.ga-event-id]="headerItem.ga_event_id"
                    [attr.ga-event-category]="headerItem.ga_event_category"
                    [attr.ga-event-label]="headerItem.ga_event_label"
                    ga-track="track"
                    *ngIf="!headerItem.subDropdownValues"
                    class="tw-text-[14px]"
                    [routerLink]="getLinkForLabel(headerItem.label)"
                >
                    {{ headerItem.label | translate }}
                </span>
            </ng-container>
        </div>

        <div class="tw-flex tw-justify-start tw-items-center">
            <img
                src="/assets/images/logo/header_desktop_white.png"
                alt="logo"
                [attr.ga-event-id]="gtmTags.IMSME_Icon_Top.event"
                [attr.ga-event-category]="gtmTags.IMSME_Icon_Top.event_category"
                [attr.ga-event-label]="gtmTags.IMSME_Icon_Top.event_label"
                ga-track="track"
                class="tw-cursor-pointer tw-h-auto tw-w-[120px]"
                (click)="toHomePage()"
            />
        </div>
        <div
            class="tw-flex tw-justify-end lg:tw-justify-center tw-items-center tw-min-w-[80px] lg:tw-min-w-[412px] xl:tw-w-full xl:tw-max-w-[540px]"
        >
            <div
                class="tw-visible tw-flex tw-flex-grow tw-justify-end tw-gap-1 tw-py-[16px] tw-items-center max"
            >
                <span
                    class="tw-text-[14px] tw-flex tw-items-center tw-cursor-pointer"
                    (click)="toggleDropdown('LANGUAGE')"
                    [matMenuTriggerFor]="LANGUAGE"
                >
                    <span>{{ lang | translate }} </span>

                    <mat-icon
                        class="tw-text-white !tw-hidden lg:!tw-inline-block tw-ml-1"
                        >language</mat-icon
                    >
                </span>
                <div
                    *ngIf="isAuthenticated"
                    class="tw-z-[5999] tw-text-[#212121]"
                >
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="menu icon"
                        class="profile-avatar tw-flex tw-items-center"
                    >
                        <svg
                            width="34"
                            height="48"
                            viewBox="0 0 34 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.0003 16.0615C14.7795 16.0615 12.9993 17.8528 12.9993 20.0625C12.9993 22.1954 14.6655 23.9345 16.7767 24.0451C16.9222 24.0332 17.0773 24.0321 17.2279 24.0449C19.33 23.9325 20.9874 22.2002 21.0012 20.0591C20.9994 17.8534 19.2064 16.0615 17.0003 16.0615ZM10.6272 20.0625C10.6272 16.5475 13.4647 13.6895 17.0003 13.6895C20.5176 13.6895 23.3733 16.5451 23.3733 20.0625V20.0692H23.3733C23.3539 23.4982 20.6567 26.3022 17.2304 26.419C17.1609 26.4214 17.0912 26.4176 17.0223 26.4078C17.0291 26.4087 17.0304 26.4086 17.0261 26.4084C17.022 26.4081 17.0152 26.4078 17.0062 26.4078C16.9867 26.4078 16.9688 26.4091 16.9576 26.4105C16.8954 26.4183 16.8327 26.4211 16.7701 26.419C13.3498 26.3024 10.6272 23.5027 10.6272 20.0625Z"
                                fill="white"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.79968 32.5767C8.5817 33.3971 7.90089 34.3358 7.6356 35.228C10.1756 37.355 13.432 38.628 17 38.628C20.5681 38.628 23.8244 37.355 26.3644 35.228C26.099 34.3354 25.4177 33.3962 24.1987 32.5756C22.2848 31.2955 19.6825 30.6182 17.0119 30.6182C14.3424 30.6182 11.731 31.295 9.79968 32.5767ZM17.0119 28.2461C20.0416 28.2461 23.1317 29.0075 25.5191 30.605L25.5217 30.6067C27.4236 31.8865 28.6336 33.6236 28.838 35.5453C28.8779 35.9198 28.7374 36.2911 28.4596 36.5455C25.4348 39.3154 21.4199 41 17 41C12.5802 41 8.56524 39.3154 5.54043 36.5455C5.26263 36.2911 5.12218 35.9198 5.16203 35.5453C5.36647 33.6236 6.57646 31.8865 8.47835 30.6067L8.48424 30.6028L8.48426 30.6028C10.8857 29.0077 13.9818 28.2461 17.0119 28.2461Z"
                                fill="white"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17 9.37209C8.92123 9.37209 2.37209 15.9212 2.37209 24C2.37209 32.0788 8.92123 38.6279 17 38.6279C25.0788 38.6279 31.6279 32.0788 31.6279 24C31.6279 15.9212 25.0788 9.37209 17 9.37209ZM0 24C0 14.6112 7.61116 7 17 7C26.3888 7 34 14.6112 34 24C34 33.3888 26.3888 41 17 41C7.61116 41 0 33.3888 0 24Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                    <mat-menu
                        class="!tw-relative !tw-z-[6999] !tw-rounded-2xl"
                        #menu="matMenu"
                    >
                        <button
                            [attr.ga-event-id]="gtmTags?.Profile?.event"
                            [attr.ga-event-category]="
                                gtmTags?.Profile?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.Profile?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/profile']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.PROFILE" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="gtmTags?.My_Application?.event"
                            [attr.ga-event-category]="
                                gtmTags?.My_Application?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.My_Application?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/dashboard']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.APPLICATION_DASHBOARD" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="
                                gtmTags?.jc3_feedback_form?.event
                            "
                            [attr.ga-event-category]="
                                gtmTags?.jc3_feedback_form?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.jc3_feedback_form?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            [routerLink]="['/feedback-form']"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "JC3.JC3_FEEDBACK_FORM" | translate }}
                        </button>
                        <hr style="border: 1px solid #d8d8d8" />
                        <button
                            [attr.ga-event-id]="gtmTags?.Log_Out?.event"
                            [attr.ga-event-category]="
                                gtmTags?.Log_Out?.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags?.Log_Out?.event_label
                            "
                            ga-track="track"
                            mat-menu-item
                            (click)="authService.signOut()"
                            class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                        >
                            {{ "COMMON.LOGOUT" | translate }}
                        </button>
                    </mat-menu>
                </div>
                <div
                    *ngIf="!isAuthenticated"
                    class="lg:tw-px-4 tw-text-[14px] tw-gap-2 tw-flex tw-items-center tw-justify-center"
                >
                    <span>
                        <button
                            [attr.ga-event-id]="gtmTags.Login.event"
                            [attr.ga-event-category]="
                                gtmTags.Login.event_category
                            "
                            [attr.ga-event-label]="gtmTags.Login.event_label"
                            ga-track="track"
                            [routerLink]="['/login']"
                            class="lg:tw-px-4 lg:tw-py-[7px] tw-px-4 tw-py-1 lg:tw-w-[115px] lg:tw-h-[48px] tw-border-2 tw-text-white tw-border-white tw-rounded-3xl"
                        >
                            {{ "COMMON.LOGIN" | translate }}
                        </button>
                    </span>
                    <span class="tw-hidden lg:tw-block">
                        <button
                            [attr.ga-event-id]="gtmTags.Get_Started.event"
                            [attr.ga-event-category]="
                                gtmTags.Get_Started.event_category
                            "
                            [attr.ga-event-label]="
                                gtmTags.Get_Started.event_label
                            "
                            ga-track="track"
                            [routerLink]="['/sign-up']"
                            class="tw-px-4 tw-py-[7px] tw-w-[143px] tw-h-[48px] tw-border tw-text-primary-blue-dark tw-bg-white tw-border-white tw-rounded-3xl"
                            [ngClass]="
                                innerWidth > innerwidthBreakpoint
                                    ? ''
                                    : 'tw-pl-[1.5rem] tw-pr-[1.5rem] tw-text-[13px]'
                            "
                        >
                            {{ "COMMON.REGISTER_NOW" | translate }}
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <mat-menu
            class="!tw-relative !tw-py-0 !tw-top-[10px] !tw-rounded-xl !tw-z-[6999] tw-w-auto tw-h-auto"
            #LANGUAGE="matMenu"
        >
            <button
                mat-menu-item
                class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                [attr.ga-event-id]="gtmTags?.en?.event"
                [attr.ga-event-category]="gtmTags?.en?.event_category"
                [attr.ga-event-label]="gtmTags?.en?.event_label"
                ga-track="track"
                (click)="switchLanguage('en', true)"
                style="padding: 0px 16px"
            >
                <p
                    class="!tw-mb-0"
                    [attr.ga-event-id]="gtmTags?.en?.event"
                    [attr.ga-event-category]="gtmTags?.en?.event_category"
                    [attr.ga-event-label]="gtmTags?.en?.event_label"
                    ga-track="track"
                >
                    {{ "LANG.EN" | translate }}
                </p>
            </button>
            <hr />
            <button
                mat-menu-item
                class="!tw-px-[16px] hover:!tw-bg-blue-500 hover:tw-text-white !tw-border-b !tw-border-b-black"
                [attr.ga-event-id]="gtmTags?.bm?.event"
                [attr.ga-event-category]="gtmTags?.bm?.event_category"
                [attr.ga-event-label]="gtmTags?.bm?.event_label"
                ga-track="track"
                (click)="switchLanguage('bm', true)"
                style="padding: 0px 16px"
            >
                <p
                    class="!tw-mb-0"
                    [attr.ga-event-id]="gtmTags?.bm?.event"
                    [attr.ga-event-category]="gtmTags?.bm?.event_category"
                    [attr.ga-event-label]="gtmTags?.bm?.event_label"
                    ga-track="track"
                >
                    {{ "LANG.BM" | translate }}
                </p>
            </button>
        </mat-menu>

        <!-- Header submenu desktop -->
        <mat-menu
            #menu="matMenu"
            class="!tw-relative !tw-py-0 !tw-top-[10px] !tw-rounded-xl !tw-z-[6999] tw-w-[254px] tw-h-auto"
        >
            <ng-container *ngIf="currentDropdownItems?.length">
                <ng-container
                    *ngFor="
                        let item of currentDropdownItems;
                        let i = index;
                        let last = last
                    "
                >
                    <button
                        [attr.ga-event-id]="
                            item.ga_event_id ? item.ga_event_id : null
                        "
                        [attr.ga-event-category]="
                            item.ga_event_category
                                ? item.ga_event_category
                                : null
                        "
                        [attr.ga-event-label]="
                            item.ga_event_label ? item.ga_event_label : null
                        "
                        [attr.ga-track]="item.ga_event_id ? 'track' : null"
                        mat-menu-item
                        [routerLink]="[item.link]"
                        class="!tw-px-[16px] !tw-py-[10px] hover:!tw-bg-blue-500 hover:tw-text-white"
                    >
                        <div
                            [attr.ga-event-id]="
                                item.ga_event_id ? item.ga_event_id : null
                            "
                            [attr.ga-event-category]="
                                item.ga_event_category
                                    ? item.ga_event_category
                                    : null
                            "
                            [attr.ga-event-label]="
                                item.ga_event_label ? item.ga_event_label : null
                            "
                            [attr.ga-track]="item.ga_event_id ? 'track' : null"
                            class="tw-flex tw-items-center tw-gap-3 tw-w-full"
                        >
                            <p
                                [attr.ga-event-id]="
                                    item.ga_event_id ? item.ga_event_id : null
                                "
                                [attr.ga-event-category]="
                                    item.ga_event_category
                                        ? item.ga_event_category
                                        : null
                                "
                                [attr.ga-event-label]="
                                    item.ga_event_label
                                        ? item.ga_event_label
                                        : null
                                "
                                [attr.ga-track]="
                                    item.ga_event_id ? 'track' : null
                                "
                                class="!tw-mb-0"
                            >
                                {{ item.label | translate }}
                            </p>
                        </div>
                    </button>
                    <hr *ngIf="!last" class="tw-my-0 tw-border-[#d1d5db]" />
                </ng-container>
            </ng-container>
        </mat-menu>
    </div>
</header>
